import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import logoU from '../../assets/images/logo-u.png';
import imgSignin from '../../assets/images/signin-logo.png';
import styles from './register-types.module.scss';
import imgDates from '../../assets/images/dates.png';

const RegisterTypes = () => (
  <div className={styles.registerTypes}>
    <Link to="/" className={styles.logo}>
      <img src={logoU} alt="Logo Coopérative U" />
    </Link>
    <div className={styles.container}>
        <div className={styles.imgContainer}>
          <h1>Bienvenue au</h1>
          <img src={imgSignin} alt="Bienvenue au salon U" />
          <img src={imgDates} alt="Dates du salon" className={styles.dates}/>
        </div>
        <div className={styles.form}>
          <h1>Je suis :</h1>
          <div className={styles.types}>
            <NavLink to='/register/magasin'>
              <button>
                Magasin
              </button>
            </NavLink>
            <NavLink to='/register/collaborateur'>
              <button>
                Collaborateur centrale
              </button>
            </NavLink>
            <NavLink to='/register/fournisseur'>
              <button>
                Fournisseur
              </button>
            </NavLink>
          </div>
        </div>
    </div>
  </div>
);

export default RegisterTypes;
